// extracted by mini-css-extract-plugin
export default {"root":"CopyrightsContent_root__c+WrJ"};